<template>
  <div id="datatable-process-type-primary-column" :class="{ 'h-100': isBoxMode }">
    <div
      class="d-flex align-items-center"
      style="gap: .5rem"
    >
      <div
        class="d-flex flex-column align-items-start mr-2"
        :class="{ 'p-3': isBoxMode }"
      >
        <span class="mb-2" :class="{ 'name-box-container h4': isBoxMode }">{{ value.alias || value.name}}</span>
        <p v-if="isBoxMode" :class="{ 'description-box-container': isBoxMode }">{{ value.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    isBoxMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass" scoped>
.name-box-container
  overflow: hidden
  text-overflow: ellipsis
  display: -webkit-box
  line-clamp: 2
  -webkit-line-clamp: 2
  -webkit-box-orient: vertical
.description-box-container
  overflow: hidden
  text-overflow: ellipsis
  display: -webkit-box
  line-clamp: 3
  -webkit-line-clamp: 3
  -webkit-box-orient: vertical
</style>
